<template>
  <!-- eslint-disable max-len -->
  <div>
    <section class="amp-vr">
      <h3 class="amp-vr__heading">
        Next, begin updating your Voter Registration.
      </h3>
      <p
        v-if="!autofill"
        class="amp-vr__body mt-2"
      >
        Just check the box and click CONTINUE to automatically fill out your voter registration form. You will be redirected from the USPS Change-of-Address website to MYMOVE in order to autofill your voter registration.
      </p>
      <p
        v-else
        class="amp-vr__body mt-2"
      >
        Just click CONTINUE to automatically fill out your voter registration form. You will be redirected from the USPS Change-of-Address website to MYMOVE in order to autofill your voter registration.
      </p>
      <InputCheckbox
        v-if="!autofill"
        id="amp-voter-reg-checkbox"
        v-model="autofill"
        name="autofill-voter-reg"
        class="c-input-checkbox--lg mt-6"
      >
        <p class="amp-vr__copy">
          By checking Autofill and continue, you are voluntarily providing your consent to transfer a copy of your personal contact information to MYMOVE in order to automatically fill out your voter registration and your MYMOVE registration.
          Or you can continue without autofill and fill out the form again.
        </p>
      </InputCheckbox>
      <p class="amp-vr__copy mt-6">
        Don't need Voter Registration right now?
      </p>
      <button
        id="offers-no-vr"
        :class="{ 'c-link--disabled': loading }"
        :disabled="loading"
        type="button"
        class="c-link text-left text-base mt-2"
        @click="next('offers', $event);"
      >
        Go directly to MYMOVE.com to see more offers and deals
      </button>
      <p class="amp-vr__legal mt-2 mb-6">
        Once on MYMOVE.com, you will be subject to the MYMOVE Privacy Policy and Terms and Conditions.
      </p>
      <div class="c-navbar">
        <button
          id="continue-vr"
          :class="{ 'c-btn--disabled': loading }"
          :disabled="loading"
          type="button"
          class="c-btn"
          @click="next('vr', $event);"
        >
          Continue
        </button>
      </div>
    </section>
    <Modal
      id="reprompt-modal"
      :value="showReprompt"
      @user-dismissed="showReprompt = false;"
    >
      <div class="sp-modal amp-vr__copy">
        <SvgStopHand />
        <h3 class="sp-modal__heading mt-5">
          Make Updating Your Voter Registration Even Easier!
        </h3>
        <p class="mt-3">
          Check the box below to share the following information with MYMOVE. Doing so will autofill your voter registration form, making updating your registration quicker and easier.
        </p>
        <div class="mt-3">
          <!-- Static checkmark list -->
          <p><span class="mr-2 ml-1">&#x2714;</span>Name and Location</p>
          <p><span class="mr-2 ml-1">&#x2714;</span>Move date</p>
          <p><span class="mr-2 ml-1">&#x2714;</span>Contact information</p>
        </div>
        <InputCheckbox
          id="amp-voter-reg-checkbox"
          v-model="autofill"
          name="reprompt-autofill"
          class="c-input-checkbox--lg mt-4"
        >
          By checking Autofill and continue, you are voluntarily providing your consent to transfer a copy of your personal contact information to MYMOVE in order to automatically fill out your voter registration and your MYMOVE registration.
          Or you can continue without autofill and fill out the form again.
        </InputCheckbox>
        <button
          id="reprompt-modal-continue"
          ref="repromptContinue"
          class="c-btn mt-4"
          @click="next('vr', $event);"
        >
          Continue
        </button>
        <p class="amp-vr__legal mt-4">
          By clicking "Continue", you will be leaving USPS.com and redirected to MYMOVE.com. Once on MYMOVE.com, you will be subject to the MYMOVE Privacy Policy and Terms and Conditions
        </p>
      </div>
    </Modal>
  </div>
</template>

<script>
import { InputCheckbox, Modal } from '@mgo/ui';
import { track } from '../../../../test-success-page/src/utils/analytics';
import SvgStopHand from '../../components/SvgStopHand.vue';
import { validateHandoffUrl } from '../../utils/commonUtil';

export default {
  name: 'VoterRegMobile',
  components: {
    InputCheckbox,
    Modal,
    SvgStopHand,
  },
  data() {
    return {
      autofill: JSON.parse(sessionStorage.getItem('autofill')) || false,
      loading: false,
      repromptShown: false,
      showReprompt: false,
    };
  },
  computed: {
    userNeedsReprompt() {
      return !this.autofill
        && !this.repromptShown
        && !this.showReprompt;
    },
  },
  methods: {
    openRepromptModal() {
      this.showReprompt = true;
      this.repromptShown = true;
    },
    trackAutofill() {
      track('ElementClicked', {
        name: `autofill-toggled-${this.autofill ? 'on' : 'off'}`,
      });
    },
    async next(flow, e) {
      this.loading = true;

      if (flow !== 'offers' && this.userNeedsReprompt) {
        track('ElementClicked', { name: 'continue-for-reprompt' });
        this.openRepromptModal();
        this.loading = false;
        return;
      }
      this.trackAutofill();
      track('ElementClicked', { name: e.target.id });
      const { url } = await this.$coa.handoffGetURL(flow, this.autofill, this.$route.query);

      const validUrl = validateHandoffUrl(url);
      if (!validUrl) {
        this.loading = false;
        return;
      }
      window.location.href = validUrl;
    },
  },
};
</script>
